import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
import { Dropdown, Form, ListGroup } from "react-bootstrap";
import { useHistory, useLocation } from "react-router";
import "../Dynamic/UserList.scss";
import CompanyInventorySummaryReport from "./CompanyInventorySummaryReport";
import CompanyBillingActivityReport from "./CompanyBillingActivityReport";
import TTBReport from "./TTBReport";
import ServiceRequestBillingReport from "./ServiceRequestBillingReport";
import CompanyBulkInventoryUploadReport from "./CompanyBulkInventoryUploadReport";
import { CommonService } from "../../Service/CommonService";
import Info from "../../assets/images/icons/Info.svg";

type ReportType = "companyInventorySummary" | "companyBillingActivity" | "ttbReporting" | "serviceRequestBilling" | "companyBulkInventoryUpload";

interface LocationState {
  reportType?: ReportType;
}

const ReportingListing: React.FC = () => {
  const history = useHistory();
  const location = useLocation<LocationState>();
  const [selectedReport, setSelectedReport] = useState<ReportType>(
    location.state?.reportType || "companyInventorySummary"
  );

  useEffect(() => {
    if (location.state?.reportType) {
      setSelectedReport(location.state?.reportType);
    }
  }, [location.state]);

  const handleReportChange = (reportType: ReportType) => {
    setSelectedReport(reportType);
  };

  return (
    <div className="usersList position-relative" style={{ paddingBottom: CommonService.isAdmin() ? 51 : "" }}>
      <div className="usersList__header--wrapper d-flex flex-wrap align-items-center gap-3">
        <div className="d-flex align-items-center gap-2">
          <IconButton aria-label="ArrowBackIcon"
            sx={{
              backgroundColor: "#FFF",
              "&:hover": { backgroundColor: "#FFF" },
            }} onClick={() => history.goBack()}>
            <ArrowBackIcon />
          </IconButton>
          <div className="header--title">
            <h1 className="title mb-0">
              Reports
            </h1>
          </div>
          <div className="company-dashboard__user--companyInfo  px-2 d-inline-block">
              <Dropdown>
                <Dropdown.Toggle variant="info">
                  <img src={Info} alt="Info" />
                </Dropdown.Toggle>

                <Dropdown.Menu className="barrel-market-tooltip">
                  <ListGroup>
                    <ListGroup.Item>
                      <div className="company-details">
                        <p className="mb-2">
                          Report includes only Whitedog-managed containers.
                        </p>
                      </div>
                    </ListGroup.Item>
                  </ListGroup>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="divider ms-2"></div>
        </div>

        <div className="report-filter-wrapper">
          <Form.Select
            value={selectedReport}
            onChange={(event) => handleReportChange(event.target.value as ReportType)}
            className="report-select"
          >
            <option value="companyInventorySummary">Inventory Summary</option>
            <option value="companyBillingActivity">Billing Activity</option>
            <option value="ttbReporting">TTB Reporting</option>
            <option value="serviceRequestBilling">Service Request Billing</option>
            <option value="companyBulkInventoryUpload">Bulk Inventory Upload</option>
          </Form.Select>
        </div>
      </div>

      <div>
        {selectedReport === "companyInventorySummary" && (
          <CompanyInventorySummaryReport />
        )}

        {selectedReport === "companyBillingActivity" && (
          <CompanyBillingActivityReport />
        )}

        {selectedReport === "ttbReporting" && (
          <TTBReport />
        )}

        {selectedReport === "serviceRequestBilling" && (
          <ServiceRequestBillingReport />
        )}

        {selectedReport === "companyBulkInventoryUpload" && (
          <CompanyBulkInventoryUploadReport />
        )}
      </div>
    </div>
  );
};

export default ReportingListing;
